import React from 'react';
import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app';
import { getAll, fetchAndActivate, getRemoteConfig, RemoteConfig } from 'firebase/remote-config';
import { useFirebaseStore } from '../store/Firebase';

export const useInitializeFirebase = ({ firebaseOptions }: { firebaseOptions?: FirebaseOptions }) => {
  const { setFirebaseApp, setRemoteConfigValues } = useFirebaseStore();

  const configureFirebaseApp = (firebaseOptions: FirebaseOptions) => {
    const firebaseApp = initializeApp(firebaseOptions);
    setFirebaseApp(firebaseApp);
    return firebaseApp;
  };

  const configureFirebaseRemoteConfig = (firebaseApp: FirebaseApp) => {
    const remoteConfig = getRemoteConfig(firebaseApp);
    remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
    return remoteConfig;
  };

  const getAndSaveRemoteConfig = async (remoteConfig: RemoteConfig) => {
    fetchAndActivate(remoteConfig).then(() => setRemoteConfigValues(getAll(remoteConfig)));
  };

  React.useEffect(() => {
    if (firebaseOptions) {
      const firebaseApp = configureFirebaseApp(firebaseOptions);

      const remoteConfig = configureFirebaseRemoteConfig(firebaseApp);

      getAndSaveRemoteConfig(remoteConfig);
    }
  }, [firebaseOptions]);
};
